import React from "react";
import { MSG_STRING, CUSTOM_MSG_STRING } from "../../../../../../../utils/Constant";
import { pushNotification } from "../../../../AdminActionCreator.component";
import Popup from '../../../../../../presentationals/Popup/Popup.component';
import { CheckFunction, Company_DATA } from "../../../../../../../layouts/MainTenantconfig";
class MessageHandler extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            templateId: '',
            popupState: false,
            popupStatus: '',
        }
    }
    messageHandler(msgType) {
         const { allDetail } = this.props;
        if (msgType == 'ExecutiveContact') {
            this.setState({ templateId: '1207161475779223316' })
            this.setState({ message: MSG_STRING.EXECUTIVE_CONTACT })
        } else if (msgType == 'DocsUpload') {
            this.setState({ templateId: '1207161475786136184' })
            this.setState({ message: MSG_STRING.DOC_MSG })
        } else if (msgType == 'razorpay') {
            this.setState({ templateId: '1207161475799205532' })
            this.setState({ message: MSG_STRING.RAZ_MSG })
        } else if (msgType === 'AutoDebitReminder') {
            this.setState({ templateId: '1207174125970484172' })
            this.setState({ message: CUSTOM_MSG_STRING.handleTemplate("AUTO_DEDBIT_REMINDER", allDetail?.firstName + " " + allDetail?.lastName) })
        } else if (msgType === 'LoanApplicationApproved') {
            this.setState({ templateId: '1207174125674920222' })
            this.setState({ message: CUSTOM_MSG_STRING.handleTemplate("LOAN_APPLICATION_APPROVED", allDetail?.firstName + " " + allDetail?.lastName) })
        } else if (msgType === 'DocumentSubmissionReminder') {
            this.setState({ templateId: '1207174125148863901' })
            this.setState({ message: CUSTOM_MSG_STRING.handleTemplate("DOCUMENT_SUBMISSION_REMINDER", allDetail?.firstName + " " + allDetail?.lastName) })
        } else if (msgType === 'OverdueLoanAlert') {
            this.setState({ templateId: '1207174125057458210' })
            this.setState({ message: CUSTOM_MSG_STRING.handleTemplate("OVERDUE_LOAN_ALERT", allDetail?.firstName + " " + allDetail?.lastName) })
        } else if (msgType === 'LoanApplicationRejected') {
            this.setState({ templateId: '1207174125279018738' })
            this.setState({ message: CUSTOM_MSG_STRING.handleTemplate("LOAN_APPLICATION_REJECTED", allDetail?.firstName + " " + allDetail?.lastName) })
        } else if (msgType === '') {
            this.setState({ templateId: '' })
            this.setState({ message: '' })
        }
    }

    sendHandler() {
        const { allDetail, admin } = this.props;
        if (this.state.message != '' && this.state.templateId != '') {
            pushNotification(allDetail, this.state.message.replace(/&/g, 'and'), '', admin.emailId, 'message', '', this.state.notificationImage, '', '', this.state.templateId,
                (callBack) => {
                    this.setState({
                        popupState: true,
                        popupStatus: 'Message Sent Successfully',
                    })
                    this.removePopup();
                })
        } else {
            this.setState({
                popupState: true,
                popupStatus: 'Please enter message',
            })
            this.removePopup();
        }
    }
    removePopup() {
        setTimeout(function () {
            this.setState({ popupState: false });
        }.bind(this), 5000)
    }

    closePopup() {
        this.setState({ popupState: false });
    }

    render() {
        const { ...tenant } = CheckFunction()
        return (
            <div className="container-fluid details-new">
                {this.state.popupState == true ?

                    <Popup
                        closePopup={this.closePopup.bind(this)}
                        popupStatus={this.state.popupStatus}
                    />
                    : ""}
                <div className="sms-box">
                    <select style={{ background: '#DBE9FF', color: '#000' }} className="form-control" onChange={(e) => this.messageHandler(e.target.value)}>
                        <option value={''}>Select Template</option>
                        {
                            tenant?.COMPANY_NAME !== Company_DATA?.ABHICASH ?
                                <>
                                    <option value='ExecutiveContact'> Executive contact </option>
                                    <option value='DocsUpload'>Document upload</option>
                                    <option value='razorpay'>Bank not live with Razorpay's e-mandate</option>
                                </>
                                :
                                <>
                                    <option value="AutoDebitReminder">Auto-Debit Reminder</option>
                                    <option value="LoanApplicationApproved">Loan Application Approved</option>
                                    <option value="DocumentSubmissionReminder">Document Submission Reminder</option>
                                    <option value="OverdueLoanAlert">Overdue Loan Alert</option>
                                    <option value="LoanApplicationRejected">Loan Application Rejected</option>
                                </>
                        }


                    </select>
                    {this.state.message !== '' ?
                        <textarea value={this.state.message} readOnly style={{ background: '#F1F7FF', color: '#000', borderRadius: '6px', border: 'none', marginTop: '20px', minHeight: '150px' }} className="form-control" />
                        : ""}
                    {this.state.message !== '' ?
                        <div>
                            <button onClick={() => this.sendHandler()} className="btn btn-primary" style={{ marginTop: '20px' }}>Send</button>
                        </div>
                        : ''}
                </div>

            </div>
        )
    }
}
export default MessageHandler